import React from "react";
import { NumericFormat } from "react-number-format";
import { v4 as uuidv4 } from "uuid";
import "devextreme/data/odata/store";
import plusimg from "../../images/common/plus.png";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { config, MAX_COST, MIN_COST } from "../../constants";
import { Switch } from "@mui/material";
import MonthPosition from "./MonthPosition";
const url = config.url.URL;
Number.prototype.countDecimals = function () {
  if (Math.floor(this.valueOf()) === this.valueOf()) return 0;

  var str = this.toString();
  if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
    return str.split("-")[1] || 0;
  } else if (str.indexOf(".") !== -1) {
    return str.split(".")[1].length || 0;
  }
  return str.split("-")[1] || 0;
};
class OneMonth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monthname: props.monthname,
      positionsData: this.props.positionsData,
      submediaState: this.props.submediaState,
      showFilterRow: true,
      showHeaderFilter: false,
      rowAlternationEnabled: true,
      showModal: false,
      showEditModal: false,
      net: this.props.net ? this.props.net : 0,
      isLC: this.props.isLC,
      technical_cost: this.props.technical_cost
        ? this.props.technical_cost
        : 0,
      fee_value: this.props.fee_value ? this.props.fee_value : 0,
      fee_calculated: this.props.fee_calculated
        ? this.props.fee_calculated
        : 0,
      final_cost: this.props.final_cost ? this.props.final_cost : 0,
      units: this.props.units ? this.props.units : 0,
      showUnitPositionSampling: this.props.showUnitPositionSampling
        ? this.props.showUnitPositionSampling
        : false,
      hasPositions:
        this.props.positionsArray && this.props.positionsArray.length > 0
          ? true
          : false,
      positionsJsonReturned: "",
      monthCount: 1,
      positionsArray: this.props.positionsArray
        ? this.props.positionsArray
        : [],
      isEditable: true,
      positionCount: 0,
      hideValue: false,
      thousandSeparator: ",",
      decimalSeparator: ".",
      isValidPosition: false
    };

    this.budgetListNameRef = React.createRef();
    this.monthPos = React.createRef();
  }

  selectedChanged(e) {
    console.log("i am inside selectedChanged OneMonth.js")
    this.setState({
      selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0]),
    });
  }

  componentDidMount() {
    console.log("i am inside componentDidMount OneMonth.js");
    
    const language = navigator.language;

    var l_thousandSeparator =
        language.startsWith("fr")
        ? " "
        : language.startsWith("en")
        ? ","
        : language.startsWith("de")
        ? "."
        : ",";

    var l_decimalSeparator =
        language.startsWith("fr")
        ? ","
        : language.startsWith("en")
        ? "."
        : language.startsWith("de")
        ? ","
        : ".";

    this.setState({
      thousandSeparator: l_thousandSeparator,
      decimalSeparator: l_decimalSeparator
    });

    console.log("Thousand Separator:", l_thousandSeparator);
    console.log("Decimal Separator:", l_decimalSeparator);
  }

  // componentDidUpdate() {
  //   console.log("i am inside componentDidUpdate OneMonth.js")
  //   if (this.state.isEditable) {
  //     var net_new = this.props.net;
  //     if (this.state.positionsArray.length == 0) {
  //       if (this.state.net != net_new) {
  //         this.setState(
  //           { net: net_new },
  //           this.setState({ isEditable: false }, this.returnMonthSetup)
  //         );
  //       }
  //     }else{ 
  //     this.buildNewJsonAndUpdateState(this.state.positionsArray)  
  //     }

  //     var isLC_new = this.props.isLC;
  //     if (this.state.isLC != isLC_new) {
  //       this.setState(
  //         { isLC: isLC_new },
  //         this.setState({ isEditable: false }, this.returnMonthSetup())
  //       );
  //     }

  //     var fee_value_new = this.props.fee_value;
  //     if (this.state.fee_value != fee_value_new) {
  //       this.setState(
  //         { fee_value: fee_value_new },
  //         this.setState({ isEditable: false }, this.returnMonthSetup)
  //       );
  //     }

  //     var technical_cost_new = this.props.technical_cost;
  //     if (this.state.technical_cost != technical_cost_new) {
  //       this.setState(
  //         { technical_cost: technical_cost_new },
  //         this.setState({ isEditable: false }, this.returnMonthSetup)
  //       );
  //     }
  //     var final_cost_new = this.props.final_cost;
  //     if (this.state.final_cost != final_cost_new) {
  //       this.setState(
  //         { final_cost: final_cost_new },
  //         this.setState({ isEditable: false }, this.returnMonthSetup)
  //       );
  //     }

  //     var fee_calculated_new = this.props.fee_calculated;
  //     if (this.state.fee_calculated != fee_calculated_new) {
  //       this.setState(
  //         { fee_calculated: fee_calculated_new },
  //         this.setState({ isEditable: false }, this.returnMonthSetup)
  //       );
  //     }
  //   }
  //   var showUnitPositionSampling_new = this.props.showUnitPositionSampling;

  //   if (this.state.showUnitPositionSampling != showUnitPositionSampling_new) {
  //     this.setState({ showUnitPositionSampling: showUnitPositionSampling_new });
  //   }

    
  // }

  componentDidUpdate(prevProps) {
    if (this.state.isEditable) {
      if (
        !Object.is(prevProps.net, this.props.net) ||
        !Object.is(prevProps.isLC, this.props.isLC) ||
        !Object.is(prevProps.technical_cost, this.props.technical_cost) ||
        !Object.is(prevProps.fee_value, this.props.fee_value) ||
        !Object.is(prevProps.final_cost, this.props.final_cost) ||
        !Object.is(prevProps.fee_calculated, this.props.fee_calculated) ||
        !Object.is(prevProps.showUnitPositionSampling, this.props.showUnitPositionSampling)
      )  {
        this.setState(
          {
            net: this.props.net,
            isLC: this.props.isLC,
            technical_cost: this.props.technical_cost,
            fee_value: this.props.fee_value,
            final_cost: this.props.final_cost,
            fee_calculated: this.props.fee_calculated,
          },
          this.returnMonthSetup
        );
      }
  
      if (
        this.state.showUnitPositionSampling !==
        this.props.showUnitPositionSampling
      ) {
        this.setState({
          showUnitPositionSampling: this.props.showUnitPositionSampling,
        });
      }
    }

    var showUnitPositionSampling_new = this.props.showUnitPositionSampling;
    if (this.state.showUnitPositionSampling != showUnitPositionSampling_new) {
      this.setState({ showUnitPositionSampling: showUnitPositionSampling_new });
    }
  }
  
  

  NetAmountChanged(event) {
    console.log("i am inside NetAmountChanged")
    var value = event.value == "" ? 0 : event.floatValue;
    var fee_value = this.state.fee_value == "" ? 0 : this.state.fee_value;
    var x_technicalcost =
      this.state.technical_cost == "" ? 0 : this.state.technical_cost;
    var x_fee_calculated = this.state.isLC
      ? fee_value
      : parseFloat((fee_value * value) / 100) == 0
      ? ""
      : this.state.isLC
      ? fee_value
      : parseFloat((fee_value * value) / 100);
    var x_final_cost =
      parseFloat(value) +
      parseFloat(this.state.isLC ? fee_value : (fee_value / 100) * value) +
      parseFloat(x_technicalcost);

    this.setState(
      {
        net: event.value == "" ? 0 : event.floatValue,
        fee_calculated: x_fee_calculated,
        final_cost:
          x_final_cost.countDecimals() > 2
            ? x_final_cost.toFixed(4)
            : x_final_cost,
        isEditable: false,
      },
      this.returnMonthSetup
    );
  }

  feeAmountChanged(event) {
    console.log("i am inside feeAmountChanged")
    var value = event.value == "" ? 0 : event.floatValue;
    var x_net_cost = this.state.net == "" ? 0 : this.state.net;
    var x_technical_cost =
      this.state.technical_cost == "" ? 0 : this.state.technical_cost;
    var x_final_cost =
      parseFloat(x_net_cost) +
      parseFloat(this.state.isLC ? value : (value / 100) * x_net_cost) +
      parseFloat(x_technical_cost);

    this.setState(
      {
        fee_value: event.value == "" ? 0 : event.floatValue,
        fee_calculated:
          event.value == ""
            ? 0
            : this.state.isLC
            ? parseFloat(value)
            : parseFloat((value * this.state.net) / 100),
        final_cost:
          x_final_cost.countDecimals() > 2
            ? x_final_cost.toFixed(4)
            : x_final_cost,
        isEditable: false,
      },
      this.returnMonthSetup
    );
  }

  technicalCostAmountChanged(event) {
    console.log("i am inside technicalCostAmountChanged")
    var value = event.value == "" ? 0 : event.floatValue;
    var x_net_cost = this.state.net == "" ? 0 : this.state.net;
    var x_fee_calculated =
      this.state.fee_calculated == "" ? 0 : this.state.fee_calculated;
    var x_final_cost =
      parseFloat(x_net_cost) +
      parseFloat(parseFloat(x_fee_calculated).toFixed(4)) +
      parseFloat(value);

    this.setState(
      {
        technical_cost: event.value == "" ? 0 : event.floatValue,
        final_cost:
          x_final_cost.countDecimals() > 2
            ? x_final_cost.toFixed(4)
            : x_final_cost,
      },
      this.returnMonthSetup
    );
  }

  switchHandler = (event) => {
    var x_technical_cost =
      this.state.technical_cost == "" ? 0 : this.state.technical_cost;
    var x_final_cost =
      parseFloat(this.state.net) +
      parseFloat(x_technical_cost);
    this.setState(
      {
        isLC: !this.state.isLC,
        fee_value: 0,
        fee_calculated: 0,
        final_cost:
          x_final_cost.countDecimals() > 2
            ? x_final_cost.toFixed(4)
            : x_final_cost,
        isEditable: false,
      },
      this.returnMonthSetup
    );
  }

  addPosition(event) {
    // debugger
    console.log("i am inside addPosition")
    let consPositionsArray = this.state.positionsArray;
    let ondeletebutton= true;
    console.log("inal Budget Res position array",  consPositionsArray)
    let monthCount = uuidv4();
    let id_test = this.state.positionCount;

    consPositionsArray.push({
      id: id_test,
      positionId: '00000000-0000-0000-0000-000000000000',
      positions:'',
      net: consPositionsArray.length==0 ? this.state.net : 0,
      technical_cost: consPositionsArray.length==0 ? this.state.technical_cost : 0,
      fee_value: consPositionsArray.length==0 ? this.state.fee_value : 0,
      isLC: consPositionsArray.length==0 ? this.state.isLC : false,
      units: 0,
      isSampling: false,
      monthNumber: this.props.monthNumber,
      fee_calculated: 0,
      final_cost: 0
     });

    //  this.setState({
    //   net:0,
    //   technical_cost:0,
    //   fee_value : 0,
    //   final_cost: 0,
    // },)

      
    // if (!this.state.hasPositions) {
    //   let budgetDetails = `"Net${this.props.monthNumber}": 0
    //     ,"TechnicalCost${this.props.monthNumber}": 0 
    //     ,"Fees${this.props.monthNumber}": 0
    //     ,"FinalCost${this.props.monthNumber}": 0
    //     ,"AbsoluteFees${this.props.monthNumber}": 0
    //     `;
    //   this.props.data.monSetupChanged(budgetDetails);
    // }
    this.setState({
      hasPositions: true,
      positionCount: this.state.positionCount + 1,
      positionsArray: consPositionsArray,
    });
    this.returnMonthSetup()
    this.buildNewJsonAndUpdateState(consPositionsArray,ondeletebutton)
    // this.props.data.monSetupChanged("");
  }
  
  deletePosition(id) {
    // debugger
    console.log("i am inside deletePosition")
    let consPositionsArray = this.state.positionsArray;
    console.log("inal Budget Res position array in delete",  consPositionsArray)
    var index = consPositionsArray.findIndex(function (o) {
      return o.id === id;
    });

    let net__cost =0;
    let technical__cost =0;
    let final__cost =0;
    let fee__val =0;
    let fee__Calculated =0;
    let isLc__new= 0

    consPositionsArray.map((position) => {
      //in case we modified our old position with no new positions added
      if (position.id === id) {
        net__cost = position.net;
        isLc__new = position.isLC;
        fee__val= position.fee_value;
        fee__Calculated= position.fee_calculated;
        technical__cost= position.technical_cost;
        final__cost=  position.final_cost ;
      }
    });
    if (index !== -1) consPositionsArray.splice(index, 1);
    if(id===0 && consPositionsArray.length===0){
      let ondeletebutton= true;
      this.setState({
        net: net__cost,
        isLC: isLc__new,
        fee_value: fee__val,
        fee_calculated:fee__Calculated,
        technical_cost: technical__cost,
        final_cost: final__cost,
        units: 0,
        isSampling: false,
        showUnitPositionSampling: false,
        hasPositions: false,
        positionsArray: [],
      },
   
      );
      this.returnMonthSetup();
      // this.props.data.positionSetupChanged('')
      this.buildNewJsonAndUpdateState(consPositionsArray, ondeletebutton)
    }else{
      this.returnMonthSetup()
      this.buildNewJsonAndUpdateState(consPositionsArray);
    }
  }
  
  returnMonthSetup() {
    // debugger
    console.log("i am inside returnMonthSetup")
    console.log("my positions array",this.props.positionsArray)
    if (this.state.positionsArray.length == 0) {
      let x_net = this.state.net == "" ? 0 : this.state.net;
      let x_technical_cost =
        this.state.technical_cost == "" ? 0 : this.state.technical_cost;
      let x_fee_value = this.state.fee_value == "" ? 0 : this.state.fee_value;
      let x_final_cost =
        this.state.final_cost == "" ? 0 : this.state.final_cost;
      let x_fee_calculated =
        this.state.fee_calculated == "" ? 0 : this.state.fee_calculated;

      // If month is in LC mode (isLC true) we send Fees as 0 and keep AbsoluteFees as the absolute value
      const feesToSend = this.state.isLC ? 0 : x_fee_value;
      let budgetDetails = `"Net${this.props.monthNumber}": ${x_net}
    ,"TechnicalCost${this.props.monthNumber}": ${x_technical_cost} 
    ,"Fees${this.props.monthNumber}": ${feesToSend}
    ,"FinalCost${this.props.monthNumber}": ${x_final_cost}
    ,"AbsoluteFees${this.props.monthNumber}": ${x_fee_calculated} 
    `;

      this.props.data.monSetupChanged(budgetDetails);
    } else {
      this.props.data.monSetupChanged("");
    }
  }

  //for positions only
  buildNewJsonAndUpdateState(consPositionsArray, ondeletebutton){
    console.log("i am inside buildNewJsonAndUpdateState")
    //preparing to build a new Json 
    let positionsDetails = "";
    let total_net = 0;
    let total_technical_cost = 0;
    let total_fees_value = 0;
    let total_final_cost = 0;
    let total_fee_value = 0;
    let total_fee_calculated = 0;
    let total_units = 0;

    //mapping through all our positions (adding new ones, updating old ones)
    consPositionsArray && consPositionsArray.map((position) => {
      positionsDetails += `{"PositionId": '${position.positionId}'    
  ,"Net${this.props.monthNumber}": ${position.net}
  ,"TechnicalCost${this.props.monthNumber}": ${position.technical_cost} 
  ,"Fees${this.props.monthNumber}": ${position.isLC ? 0 : position.fee_value}
  ,"FinalCost${this.props.monthNumber}":${position.final_cost}
  ,"AbsoluteFees${this.props.monthNumber}":${position.fee_calculated} 
  ,"Units${
    this.props.monthNumber > 9
      ? this.props.monthNumber
      : "0" + this.props.monthNumber
  }":${position.units} 
  ,"Sampling${
    this.props.monthNumber > 9
      ? this.props.monthNumber
      : "0" + this.props.monthNumber
  }":${position.isSampling} 
  },`;
      total_fee_calculated += parseFloat(position.fee_calculated);
      total_net += parseFloat(position.net);
      total_technical_cost += parseFloat(position.technical_cost);
      total_fees_value += parseFloat(position.fee_value);
      total_final_cost += parseFloat(position.final_cost);
      total_fee_value += parseFloat(position.fee_value);
      total_units += parseFloat(position.units);
    });

    if (positionsDetails != "") {
      //removing the last "," to build a working JSON string
      positionsDetails = positionsDetails.slice(0, -1);
    }

    //to make our inputs empty "Not zeroes" after we delete a position
    // debugger
    if(consPositionsArray.length !==0){
      this.setState({
        net: total_net,
        technical_cost:  total_technical_cost,
        fee_value:  total_fee_value,
        fee_calculated:  total_fee_calculated,
        final_cost:  total_final_cost,
        units: total_units,
        showUnitPositionSampling: true,
        hasPositions: true,
        positionsArray: consPositionsArray,
      })
    }
    else{
      this.setState({
        showUnitPositionSampling: false,
        hasPositions: false,
        positionsArray: consPositionsArray,
      })
    }

      this.props.data.positionSetupChanged(positionsDetails)
  }

  //this function will send the JSON realted to positions rows
  positionSetupChanged(id, newPositionDetails) {
    console.log("i am inside positionSetupChanged")
    var new_positions = this.state.positionsArray;
    //looping over the old possition array
    new_positions.map((position) => {
      //in case we modified our old position with no new positions added
      if (position.id === id) {
        position.final_cost = newPositionDetails.final_cost;
        position.technical_cost =
          newPositionDetails.technical_cost === ""
            ? 0
            : newPositionDetails.technical_cost;
        position.net =
          newPositionDetails.net === "" ? 0 : newPositionDetails.net;
        position.fee_calculated =
          newPositionDetails.fee_calculated === ""
            ? 0
            : newPositionDetails.fee_calculated;
        position.isLC = newPositionDetails.isLC;
        position.positionId = newPositionDetails.positionId;
        position.units =
          newPositionDetails.units === "" ? 0 : newPositionDetails.units;
        position.isSampling = newPositionDetails.isSampling;
        position.fee_value =
          newPositionDetails.fee_value === ""
            ? 0
            : newPositionDetails.fee_value;
      }
    });
      this.buildNewJsonAndUpdateState(new_positions)
      
  }

/**
 * Validates each position in the positionsArray by checking if its key values are non-zero,
 * and updates the state with the validity status (isValid) for each position.
 */
  validatePositions(callback) {
    let consPositionsArray = this.state.positionsArray.map(position => {
      let isValid = position.positionId != "00000000-0000-0000-0000-000000000000";

      return {
        ...position,
        isValid: isValid
      };
    });

    // Update the state and then invoke the callback with the updated array
    this.setState({ positionsArray: consPositionsArray }, () => {
      if (callback && typeof callback === "function") {
        callback(consPositionsArray); // Pass the updated array to the callback
      }
    });
  }

  /*
  deleteEmptyPos() {
    console.log("i am inside deleteEmptyPos")
    let consPositionsArray = [];
    let i = 0;
    consPositionsArray = this.state.positionsArray;
    let positionsExists = false;
    if(consPositionsArray.length===1){
      if (
        consPositionsArray[i].positionId ==
          "00000000-0000-0000-0000-000000000000"
      ) {
       this.deletePosition(0);
        return;
      }
    }else{
      for (i = 0; i < consPositionsArray.length; i++) {
        if (
          consPositionsArray[i].net == 0 &&
          consPositionsArray[i].fee_value == 0 &&
          consPositionsArray[i].technical_cost == 0
        ) {
          positionsExists = true;
          consPositionsArray.splice(i, 1);
          i--;
          continue;
        }
      }
    }


    if (positionsExists) {
     this.buildNewJsonAndUpdateState(consPositionsArray);
    }
  }
*/
  //deleting every single position when changing from "Print" media
  cleanupPositions(fromHideLines) {
    console.log("i am inside cleanupPositions")
    this.setState({
      net: 0,
      technical_cost: 0,
      fee_value: 0,
      fee_calculated: 0,
      final_cost: 0,
      units: 0,
      hasPositions: false,
      positionsArray: [],
      positionCount: 0,
    });

   // to make our inputs empty "Not zeroes" after we change media from "Print"
    // if(fromHideLines){
      // debugger
      //     this.setState({
      //   net: this.state.net,
      //   technical_cost: this.state.technical_cost,
      //   fee_value: this.state.fee_value,
      //   fee_calculated: this.state.fee_calculated,
      //   final_cost: this.state.final_cost,
      //   units: this.state.units,
      //   },this.returnMonthSetup);
    //   }

      // this.setState({
      //   net: this.state.net,
      //   technical_cost: this.state.technical_cost,
      //   fee_value: this.state.fee_value,
      //   fee_calculated: this.state.fee_calculated,
      //   final_cost: this.state.final_cost,
      //   units: this.state.units,
      // });
      // this.returnMonthSetup()
    // let budgetDetails = "";
    this.buildNewJsonAndUpdateState([]);
    // this.props.data.positionSetupChanged(budgetDetails);
    // this.returnMonthSetup()
  }

  


  render() {
    return (
      <div
        className={`${
          this.state.positionsArray.length == 0 &&
          !this.state.net &&
          this.state.technical_cost &&
          this.state.fee_value
            ? "div-monthly-setup-container_month padding-bot2"
            : (this.state.positionsArray.length == 0 &&
                !this.state.net &&
                this.state.technical_cost) ||
              (this.state.positionsArray.length == 0 &&
                !this.state.net &&
                this.state.fee_value)
            ? "div-monthly-setup-container_month padding-bot"
            : "div-monthly-setup-container_month"
        }`}
      >
        <div className="div-monthly-setup-container-header">
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col1">
            <label className="form-label">
              {this.state.monthname}
              {this.props.submediaState
                ? (this.state.positionsArray && this.state.positionsArray.length
                  ? <span className="form-label-position"> ({this.state.positionsArray.length} Position{this.state.positionsArray.length > 1 ? 's' : ''})</span>
                  : <span className="form-label-position"> (No Position)</span>)
                : ''}
            </label>
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col2">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              className={`${
                this.state.positionsArray.length == 0 &&
                !this.state.net &&
                this.state.technical_cost &&
                this.state.fee_value
                  ? "validation-control budgetTextBox"
                  : (this.state.positionsArray.length == 0 &&
                      !this.state.net &&
                      this.state.technical_cost) ||
                    (this.state.positionsArray.length == 0 &&
                      !this.state.net &&
                      this.state.fee_value > 0)
                  ? "validation-control budgetTextBox"
                  : "budgetTextBox"
              }`}
              ref="net"
              decimalScale={2}
              value={this.state.net === 0 ? "" : this.state.net}
              onValueChange={(event) => this.NetAmountChanged(event)}
              disabled={this.state.hasPositions || this.state.hideValue}
              isAllowed={(values) => {
                const { floatValue } = values;
                if (values.value === "") {
                  this.setState({ net: "" });
                  return true;
                }
                const decimalPart = values.value.split('.')[1];
                return (
                  floatValue >= MIN_COST &&
                  floatValue <= MAX_COST &&
                  (!decimalPart || decimalPart.length <= 2)
                );
              }}
            />

            {this.state.positionsArray.length == 0 &&
            !this.state.net &&
            this.state.technical_cost &&
            this.state.fee_value ? (
              <p className="p-error2">
                Net cost for this month must be defined because a technical cost is entered
                <br />Net cost for this month must be defined because fees cost is entered
              </p>
            ) : this.state.positionsArray.length == 0 &&
              !this.state.net &&
              this.state.fee_value ? (
              <p className="p-error">
                Net cost for this month must be defined because fees cost is entered
              </p>
            ) : this.state.positionsArray.length == 0 &&
              !this.state.net &&
              this.state.technical_cost ? (
              <p className="p-error">
                Net cost for this month must be defined because a technical cost is entered
              </p>
            ) : (
              ""
            )}
          </div>

          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col3">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="technical_cost"
              value={
                this.state.technical_cost === 0 ? "" : this.state.technical_cost
              }
              onValueChange={(event) => this.technicalCostAmountChanged(event)}
              className="budgetTextBox"
              decimalScale={2}
              disabled={this.state.hasPositions || this.state.hideValue}
              isAllowed={(values) => {
                const { floatValue } = values;
                if (values.value == "") {
                  this.setState({ technical_cost: "" });
                  return true;
                }
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className="div-monthly-setup-container-cell div-monthly-setup-container-col4 budget-total"
          >
            <div className={this.state.hasPositions ? "hidden" : ""}>
              %
              <Switch
                checked={this.state.isLC}
                onClick={this.switchHandler}
                disabled={this.state.hideValue}
              />
              LC
            </div>
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col5">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="fee_value"
              // value={this.state.fee_value}
value={this.state.fee_value === 0 ? "" : this.state.fee_value}
              onValueChange={(event) => this.feeAmountChanged(event)}
              className={this.state.hasPositions ? "hidden" : "budgetTextBox"}
              decimalScale={2}
              disabled={this.state.hasPositions || this.state.hideValue}
              readOnly={this.state.hasPositions}
              isAllowed={(values) => {
                const { floatValue } = values;

                if (values.value == "") {
                  this.setState({ fee_value: "" });
                  return true;
                }
                if (this.state.isLC) {
                  return floatValue >= MIN_COST && floatValue <= MAX_COST;
                } else {
                  return floatValue >= 0 && floatValue <= 100;
                }
              }}
            />
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col6">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="fee_calculated"
              valueIsNumericString={true}
              value={
                this.state.fee_calculated != 0
                  ? parseFloat(this.state.fee_calculated).toFixed(2)
                  : ""
              }
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              readOnly={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                if (values.value == "") {
                  this.setState({ fee_calculated: "" });
                  return true;
                }
                  return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div className="div-monthly-setup-container-cell div-monthly-setup-container-col7">
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="final_cost"
              valueIsNumericString={true}
              value={
                this.state.final_cost != 0
                  ? parseFloat(this.state.final_cost).toFixed(2)
                  : ""
              }
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              readOnly={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= MIN_COST && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col8 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col8 hidden"
            }
          >
            <NumericFormat
              thousandSeparator={this.state.thousandSeparator}
              decimalSeparator={this.state.decimalSeparator}
              ref="units"
              value={this.state.units === 0 ? "" : this.state.units}
              className="budgetTextBox"
              decimalScale={2}
              disabled={true}
              readOnly={true}
              isAllowed={(values) => {
                const { floatValue } = values;
                return floatValue >= 0 && floatValue <= MAX_COST;
              }}
            />
          </div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col9 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col9 hidden"
            }
          ></div>
          <div
            className={
              this.state.showUnitPositionSampling
                ? "div-monthly-setup-container-cell div-monthly-setup-container-col10 "
                : "div-monthly-setup-container-cell div-monthly-setup-container-col10 hidden"
            }
          >
            <img
              style={{
                maxHeight: "16px",
                cursor:
                  !this.props.submediaState || this.state.hideValue
                    ? "not-allowed"
                    : "pointer",
                filter: this.state.hideValue ? "grayscale(100%)" : "none",
                opacity: this.state.hideValue ? "0.5" : "1",
              }}
              alt="adding pos"
              src={plusimg}
              onClick={
                !this.props.submediaState || this.state.hideValue
                  ? null
                  : (event) => this.addPosition(event)
              }
              title={
                !this.props.submediaState
                  ? "Please select a Submedia to add new Positions"
                  : ""
              }
            />
          </div>
        </div>
        {this.state.positionsArray.map((position, index) => {
          return (
            <MonthPosition
              key={index}
              ref={this.monthPos}
              id={position.id}
              positionId={position.positionId}
              net={position.net}
              isLC={position.isLC}
              technical_cost={position.technical_cost}
              isSampling={position.isSampling}
              fee_value={position.fee_value}
              units={position.units}
              monthNumber={position.monthNumber}
              data={{
                positionSetupChanged: this.positionSetupChanged.bind(this),
                deletePosition: this.deletePosition.bind(this),
              }}
              positionsData={this.props.positionsData}
              hidePosValue={this.state.hideValue}
              hideValue={this.state.hideValue}
              isValid={position.isValid !== undefined ? position.isValid : true}
            />
          );
        })}
      </div>
    );
  }
}

export default OneMonth;
